import service from '@/services/types/tipoIdentificacion'

// export const namespaced = true;

export const state = () => ({
  list: []
})

export const mutations = {
  LIST: (state, objs) => (state.list = objs)
}

export const actions = {
  list: ({ commit, state }, value) => (state.list.length !== 0 ? state.list : service.list(value).then(result => commit('LIST', result) || result))
}

export const getters = {
  getTipoIdentificacion: state => _id => state.list.find(({ id }) => id === _id),
  getTipoIdentificacionId: state => annotation => (state.list.length !== 0 ? state.list.find(item => item.annotation === annotation).id : null)
}
